import { store } from '../app/store';
import { api, authApi } from './api';
const axiosBaseQuery = () => async ({ url, method = 'get', data, params, headers, }) => {
    const token = store.getState().authSlicer.user.token;
    try {
        const result = token
            ? await authApi({
                url,
                method,
                data,
                headers,
                params,
            })
            : await api({
                url,
                method,
                data,
                headers,
                params,
            });
        return { data: result.data };
    }
    catch (axiosError) {
        const err = axiosError;
        return {
            error: {
                status: err.response?.status,
                data: err.response?.data || err.message,
            },
        };
    }
};
export default axiosBaseQuery;
